/* unplugin-vue-components disabled */
export default {
  name: 'node-card',
  props: {
    node: {type: Object, required: true},
    expanded: {type: Boolean, default: false}
  },
  emits: ['toggle'],
  computed: {
    name() {
      return $utils.str.decodeHTMLEntities(this.node.name)
    },
    title() {
      return $utils.str.decodeHTMLEntities(this.node.title)
    },
    avatar_url() {
      return this.node.avatar_url
    },
    entity_match() {
      const match = this.name.match(/\[([^\]]+)\]\((entity:\/\/[^)]+)\)/)
      return match
    },
    entity_href() {
      if (!this.entity_match) return
      const [,, entity_href] = this.entity_match
      return entity_href
    },
    display_name() {
      if (!this.entity_match) return this.name
      const [, name] = this.entity_match
      return name
    },
    children_count() {
      return this.node.children?.length || 0
    },
  }
}
